/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedNoteCreatedByUser
 */
export interface BedNoteCreatedByUser {
    /**
     * 
     * @type {string}
     * @memberof BedNoteCreatedByUser
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof BedNoteCreatedByUser
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof BedNoteCreatedByUser
     */
    last_name?: string;
}

/**
 * Check if a given object implements the BedNoteCreatedByUser interface.
 */
export function instanceOfBedNoteCreatedByUser(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function BedNoteCreatedByUserFromJSON(json: any): BedNoteCreatedByUser {
    return BedNoteCreatedByUserFromJSONTyped(json, false);
}

export function BedNoteCreatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedNoteCreatedByUser {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'first_name': !exists(json, 'first_name') ? undefined : json['first_name'],
        'last_name': !exists(json, 'last_name') ? undefined : json['last_name'],
    };
}

export function BedNoteCreatedByUserToJSON(value?: BedNoteCreatedByUser | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'first_name': value.first_name,
        'last_name': value.last_name,
    };
}

